import { Component, Prop, State, Event, h, type EventEmitter, Listen, Watch } from '@stencil/core';
import type { ConversationalSearchMessages } from '../../conversational-search-types/conversational-search-types.type';
import {getCorrectObjectForFollowUpActions, newMessageHandler, updateDynamicArray } from './mediators-wrapper-helpers';
import { ConversationalSearchProcessing } from '../../conversational-search-partials/processing/processing';
import { removeUIDSessionStorageValue } from '../../conversational-search-logic/storage-manager/storage-manager-helpers';
import type { labelProviderInterface } from '../../../../LabelProviderInterface';
import dynamicBannerStore from '../../conversational-search-banners/dynamic/dynamic-banner-mediator/dynamic-banner-store';
import { renderCorrectMediator } from './mediators-wrapper-rendering-helpers';

@Component({
  tag: 'uiaas-search-widget-conversational-search-messages-mediators-wrapper',
  styleUrl: 'mediators-wrapper.scss',
  shadow: false,
})
export class ConversationalSearchMessagesMediatorsWrapper {
  @Prop() readonly labelProvider: labelProviderInterface;
  @Prop() readonly searchQuery: string;
  @Prop() readonly chatQuery: string;
  @Prop() readonly language: string;
  @Prop() readonly country: string;
  @Prop() readonly apigeeAuth: string;
  @Prop() readonly apigeeTokenUrl: string;
  @Prop() readonly conversationalSearchProductsEndpoint: string;
  @Prop() readonly conversationalSearchBrandUrl: string;
  @Prop() readonly conversationalSearchMedaliaFormId: string;
  @Prop() readonly chatQueryIndex: number;

  @State() dynamicMessages: ConversationalSearchMessages[] = [];
  @State() updateView: boolean;
  @State() isNewConversation = false;
  @State() procssing = false;
  @State() isPreloadVariant = true;

  // eslint-disable-next-line
  public bannerTimeout; //! It is required to be public in order to inject the value in helpers

  @Event({
    eventName: 'conversational-search:user-question-state',
    composed: true,
    cancelable: true,
    bubbles: true,
  })
    userPromptQuestionEventEmitter: EventEmitter<{ isProcessing: boolean }>;

  @Event({
    eventName: 'conversational-search:messages-update',
    composed: true,
    cancelable: true,
    bubbles: true,
  })
    messagesUpdateEventEmitter: EventEmitter;

  @Event({
    eventName: 'conversational-search:invoke-scrollbar',
    composed: true,
    cancelable: true,
    bubbles: true,
  })
    scrollbarInvokerEventEmitter: EventEmitter;

  @Event({
    eventName: 'conversational-search:context-changed',
    composed: true,
    cancelable: true,
    bubbles: true,
  })
    contextChangedEventEmitter: EventEmitter;

  @Listen('conversational-search:user-new-conversation', { target: 'window' })
  handleConversationReset() {
      this.dynamicMessages = [];
      this.isNewConversation = true;
      dynamicBannerStore.set('isRefinement', false);
  }

  @Listen('conversational-search:user-end-of-conversation', { target: 'window' })
  handleEndOfCovnersation() {
      removeUIDSessionStorageValue();
      this.isPreloadVariant = false;
  }

  @Listen('guided:SearchCompleted', { target: 'window' })
  refreshMediatorVariant() {
      this.isPreloadVariant = true;
  }

  @Listen('conversational-search:follow-up-actions', { target: 'window' })
  async handleFollowUpActions(e) {
      const dataToPush = getCorrectObjectForFollowUpActions(e.detail.indentifier, this.chatQuery);
      await updateDynamicArray(dataToPush, this);
      this.updateView = !this.updateView;
  }

  @Watch('chatQueryIndex')
  handleNewchatQuery() {
      if (this.chatQuery) newMessageHandler(this.chatQuery, this);
  }

  componentDidRender() {
      this.scrollbarInvokerEventEmitter.emit();
  }

  disconnectedCallback() {
      clearTimeout(this.bannerTimeout);
  }

  render() {
      return (
        <section class="conversational-search-mediators-wrapper">
          {renderCorrectMediator(this)}
          {this.dynamicMessages.map((message, index) => (
            <uiaas-search-widget-conversational-search-messages-dynamic-mediator
              data={message}
              labelProvider={(e, f) => this.labelProvider(e, f)}
              query={message.query ?? this.searchQuery}
              country={this.country}
              language={this.language}
              conversationalSearchMedaliaFormId={this.conversationalSearchMedaliaFormId}
              conversationalSearchBrandUrl={this.conversationalSearchBrandUrl}
            />
          ))}
          {this.procssing ? <ConversationalSearchProcessing /> : ''}
        </section>
      );
  }
}
